'use client';

import { Link } from 'react-router-dom';

/**
 * PCヘッダー
 */
export default function Header() {
  return (
    <header className="select-none px-8 py-4">
      <Link to="/home">
        <img src="/footballlog.svg" alt="logo" width={160} height={32.5} />
      </Link>
    </header>
  );
}
